import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { lightTheme as theme } from '../../theme';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    min-width: 260px;
`;

const Label = styled.label`
    font-size: 13px;
    font-weight: 600;
    color: ${theme.colors.text};
`;

const SelectWrapper = styled.div`
    position: relative;
`;

const NativeSelect = styled.select`
    width: 100%;
    height: 40px;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    border: 1px solid ${theme.colors.gray300};
    border-radius: 8px;
    background: ${theme.colors.paper};
    color: ${theme.colors.text};
    padding: 0 34px 0 12px;
    font-size: 14px;
    line-height: 1.2;

    &:focus {
        outline: none;
        border-color: ${theme.colors.info};
        box-shadow: 0 0 0 2px rgba(13, 110, 253, 0.12);
    }
`;

const Arrow = styled.span`
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: ${theme.colors.textMuted};
    pointer-events: none;
    font-size: 11px;
`;

function SelectField({ id, label, value, onChange, options }) {
    return (
        <Wrapper>
            <Label htmlFor={id}>{label}</Label>
            <SelectWrapper>
                <NativeSelect id={id} value={value} onChange={onChange}>
                    {options.map((option) => (
                        <option key={String(option.value)} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </NativeSelect>
                <Arrow>v</Arrow>
            </SelectWrapper>
        </Wrapper>
    );
}

SelectField.propTypes = {
    id: PropTypes.string,
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    onChange: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
            label: PropTypes.string.isRequired,
        })
    ).isRequired,
};

SelectField.defaultProps = {
    id: 'select-field',
};

export default SelectField;
